<template>
  <van-popup v-model="show" :close-on-click-overlay="false" class="container"	>
    <div class="dow-box">
      <div class="updata">
        <img src="~@/assect/upbj.png" style="width: 100%;">
        <img src="~@/assect/newhuojian.png" class="rocket">
        <p class="newversion">
          发现新版本
          <span class="vers">
            V.{{ versionNo }}
          </span>
        </p>
      </div>
      <div class="dow-load">
        <div :class="isForce?'dow-loadbox':'dow-loadbox2'">
          <van-button v-if="!isForce" type="default" @click="elDelHandel">取消下载</van-button>
          <van-button v-if="isbnt" :type="isForce?'info':'default'" class="bnt-updata" block @click="download">
            立即下载
          </van-button>
        </div>
        <van-progress v-if="!isbnt" :percentage="cound" />
      </div>
    </div>
  </van-popup>
</template>
<script>
import { Popup, Button, Progress } from 'vant'
import { throttle } from '@/utils'
export default {
  name: 'Updata',
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Progress.name]: Progress
  },
  data() {
    return {
      show: true,
      cound: 0,
      isForce: '',
      url: '',
      versionNo: '',
      isbnt: true
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 下載
    download() {
      this.isbnt = false
      var fileTransfer = new FileTransfer()
      console.log('url', this.url)
      var uri = encodeURI(this.url)
      var file = cordova.file.externalDataDirectory
      var fileURL = encodeURI(file + 'update.apk')
      this.onprogress(fileTransfer)
      throttle(this.onprogress, 1000)(fileTransfer)
      fileTransfer.download(uri, fileURL,
        entry => {
          var openUrl = entry.toURL()
          this.fileOpener(openUrl)
        },
        error => {
          console.log('download error source ' + error.source)
          console.log('download error target ' + error.target)
          console.log('upload error code' + error.code)
        }
      )
    },
    // 進度
    onprogress(fileTransfer) {
      fileTransfer.onprogress = throttle(progressEvent => {
        if (progressEvent.lengthComputable) {
          var downloadProgress = (progressEvent.loaded / progressEvent.total) * 100
          this.cound = Math.floor(downloadProgress)
        }
      }, 1000)
    },
    // 打開文件
    fileOpener(openUrl) {
      cordova.plugins.fileOpener2.open(
        openUrl,
        'application/vnd.android.package-archive',
        {
          error: function(e) {
            console.log('Error status: ' + e.status + ' - Error message: ' + e.message)
          },
          success: function() {
            this.remove()
          }
        }
      )
    },
    elDelHandel() {
      this.remove()
    }
  }

}
</script>

<style lang="less" scoped>
.container{
  overflow: inherit;
}
.dow-box{
  .vers{
    font-size: 35px;
    margin-top: 8px;
    display: block;
    font-weight: 600;
    margin-left: 4px;
  }
  position: relative;
  .rocket{
      width:46%;
     position: absolute;
     top: -80px;
     right: 5px;
  }
  .newversion{
    color: #fff;
    position: absolute;
    top: 30px;
    font-size: 42px;
    font-weight: 700;
    left: 76px;
    letter-spacing: 1px;
  }
}
.van-popup--center{
   border-radius: 14px;
}
.dow-load{
  width: 80vw;
  margin: 0 auto;
  max-height: 320px;
  border-top:1px solid#eaeaea;
  .dow-loadbox{
      padding:10px;
  }
  .dow-loadbox2{
    display: flex;
    border-radius: 0 0 14px 14px;
    overflow: hidden;
    /deep/ .van-button{
      flex: 1;
      height: 52px;
    }
    .bnt-updata{
      color:#1989fa;
    }
  }
  .bnt-updata{
    width: 100%;

  }
  /deep/.van-progress{
   margin: 20px 0;
  }

}

</style>
